import { Avatar } from "antd";
// import { formatNumberKMBT } from "pages/influencers/InfluencerCard";
import "./PendingActivities.scss";

interface CreatorInfoProps {
  avatarUrl?: string | null;
  name?: string;
  username?: string;
  instagramFollowersCount?: number;
  tiktokFollowersCount?: number;
}

const CreatorInfo: React.FC<CreatorInfoProps> = ({
  avatarUrl,
  name,
  // username,
  // instagramFollowersCount,
  // tiktokFollowersCount,
}) => {
  return (
    <>
      <div className="creator-block">
        <Avatar
          src={avatarUrl}
          alt={name || "creator"}
          className="creator-avatar"
        />

        <div className="creator-meta">
          <div className="creator-name">{name || "Creator"}</div>
        </div>
      </div>
      <div
        className="booking-divider"
        aria-hidden="true"
        style={{
          width: 1,
          backgroundColor: "rgba(0,0,0,0.08)",
          margin: "12px 16px",
          alignSelf: "stretch",
        }}
      />
    </>
  );
};

export default CreatorInfo;
